var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Footer")]),_c('router-link',{attrs:{"to":{name: 'style-guide'},"tag":"span"}},[_c('Button',{attrs:{"type":"button","label":"Style Guide","status":"normal","isText":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }